import React, { useEffect, useState } from "react";
import { Package, AlertTriangle, Search } from "lucide-react";
import { toast } from "sonner";
import client, { errText } from "@/lib/api";

export default function AdminInventory() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [lowOnly, setLowOnly] = useState(false);

  const load = () => client.get("/admin/products").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setStock = async (id, val) => {
    const stock = Math.max(0, parseInt(val) || 0);
    try { await client.put(`/admin/products/${id}`, { stock }); setItems((p) => p.map((x) => x.id === id ? { ...x, stock, lowStock: stock <= 10 } : x)); }
    catch (e) { toast.error(errText(e)); }
  };

  const shown = items.filter((p) => (!lowOnly || p.lowStock) && (!q || (p.name + p.store).toLowerCase().includes(q.toLowerCase())));
  const lowCount = items.filter((p) => p.lowStock).length;

  return (
    <div dir="rtl">
      <h2 className="font-head text-[16px] font-bold px-4 pt-5 pb-2 flex items-center gap-1.5"><Package size={17} style={{ color: "var(--k-gold-deep)" }} /> المخزون ({items.length})</h2>
      <div className="px-4 pb-2 flex gap-2 items-center flex-wrap">
        <div className="relative flex-1 min-w-[180px]">
          <Search size={15} className="absolute right-3 top-1/2 -translate-y-1/2" style={{ color: "var(--k-ink-soft)" }} />
          <input data-testid="inv-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="ابحث بالمنتج أو المتجر" className="w-full rounded-xl pr-9 pl-3 py-2.5 text-[13px]" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)" }} />
        </div>
        <button data-testid="inv-low-toggle" onClick={() => setLowOnly((v) => !v)} className="k-tap px-3 py-2.5 rounded-xl text-[12px] font-bold flex items-center gap-1.5" style={{ background: lowOnly ? "var(--k-ruby)" : "var(--k-paper)", color: lowOnly ? "#fff" : "var(--k-ruby)", border: "1px solid var(--k-line)" }}><AlertTriangle size={14} /> منخفض ({lowCount})</button>
      </div>
      <div className="px-4 pb-6 space-y-2">
        {shown.map((p) => (
          <div key={p.id} data-testid={`inv-row-${p.id}`} className="rounded-xl p-3 flex items-center gap-3" style={{ background: "var(--k-surface)", border: `1px solid ${p.lowStock ? "var(--k-ruby)" : "var(--k-line)"}` }}>
            <div className="flex-1 min-w-0">
              <div className="font-bold text-[13px] truncate">{p.name}</div>
              <div className="text-[11px]" style={{ color: "var(--k-ink-soft)" }}>{p.store} · بيع {p.sold || 0}</div>
            </div>
            {p.lowStock && <span className="text-[10px] font-bold px-2 py-0.5 rounded-full" style={{ background: "rgba(220,53,69,.1)", color: "var(--k-ruby)" }}>منخفض</span>}
            <div className="text-center">
              <div className="text-[9px] mb-0.5" style={{ color: "var(--k-ink-soft)" }}>المخزون</div>
              <input data-testid={`inv-stock-${p.id}`} type="number" defaultValue={p.stock} onBlur={(e) => setStock(p.id, e.target.value)} className="w-20 text-center rounded-lg px-2 py-1.5 text-[13px] font-num font-bold" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)" }} />
            </div>
          </div>
        ))}
        {shown.length === 0 && <p className="text-[13px]" style={{ color: "var(--k-ink-soft)" }}>لا توجد نتائج</p>}
      </div>
    </div>
  );
}
